import React, { useContext, useEffect, useState } from 'react'
import { AuthContext } from './AuthContext';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { getAvatar } from '../commonfunctions';

const AppLayout = (props) => {
  const { user, logout } = useContext(AuthContext);
  const [showProfileMenu,setShowProfileMenu] = useState(false);
  const navigate = useNavigate();

  const location = useLocation();

  // State for sidebar visibility
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // Function to toggle sidebar
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  useEffect(() => {
    // This code runs after the component renders
    const sidebarElement = document.querySelector('.vertical-sidebar'); // Find the element dynamically added by the theme

    if (sidebarElement) {
      if (!isSidebarOpen) {
        // Add 'semi-nav' if sidebar should be closed/collapsed
        sidebarElement.classList.add('semi-nav');
      } else {
        // Remove 'semi-nav' if sidebar should be open
        sidebarElement.classList.remove('semi-nav');
      }
    } else {
        // Optional: Log a warning if the element isn't found
        console.warn("Could not find '.vertical-sidebar' element to toggle class.");
    }

    // No cleanup needed here as we are just adding/removing a class
  }, [isSidebarOpen]); // Re-run this effect whenever isSidebarOpen changes


  const handleLogout = () => {
    // setToken(null);
    logout();
    localStorage.removeItem('token');
    navigate('/login');

  };

  return (
    <>
   
 
      <>
     <div className="app-wrapper">

      {/* Explicit Close Button for Mobile */}
           {/* <button
             type="button"
             className="btn-close d-lg-none" // Show only on smaller screens
             aria-label="Close"
             onClick={toggleSidebar} // Use the toggle function
             style={{ position: 'absolute', top: '15px', right: '15px', zIndex: 1050, filter: 'invert(1) grayscale(100%) brightness(200%)' }} // Basic styling, adjust as needed
           ></button> */}

  {/* <div className="loader-wrapper">
    <div className="loader_24" />
  </div> */}
  {/* Menu Navigation starts */}
  <nav>
    <div className="app-logo">
      <a className="logo d-inline-block" href="index.html">
        <img alt="#" src={process.env.REACT_APP_API_BASE_URL + process.env.REACT_APP_LOGO_PATH} /> 
      </a>
      <span className="bg-light-primary toggle-semi-nav d-flex-center"  onClick={toggleSidebar}>
        <i className="ti ti-chevron-right" />
      </span>
      <div className="d-flex align-items-center nav-profile p-3">
        <span className="h-45 w-45 d-flex-center b-r-10 position-relative  m-auto">
          <img alt="avatar" className="img-fluid b-r-10" src={getAvatar(user.profile_pic_path,user?.personalInformation?.gender)} />
          <span className="position-absolute top-0 end-0 p-1 bg-success border border-light rounded-circle" />
        </span>
        <div className="flex-grow-1 ps-2">
          <h6 className="text-primary mb-0"> {user.name}</h6>
          <p className="text-muted f-s-12 mb-0">{user?.current_organization?.name}</p>
        </div>
        <div className="dropdown profile-menu-dropdown">
          <a onClick={() => setShowProfileMenu(!showProfileMenu)} aria-expanded="false" data-bs-auto-close="true" data-bs-placement="top" data-bs-toggle="dropdown" role="button">
            <i className="ti ti-settings fs-5" />
          </a>
          <ul className={`dropdown-menu ${showProfileMenu ? 'show' : ''}`}>
            <li className="dropdown-item">
              <Link to="/club_portal/profile" className="f-w-500" >
                <i className="ph-duotone  ph-user-circle pe-1 f-s-20" /> Profile Details
              </Link>
            </li>
            {/* <li className="dropdown-item">
              <a className="f-w-500" href="setting.html" target="_blank">
                <i className="ph-duotone  ph-gear pe-1 f-s-20" /> Settings
              </a>
            </li> */}
            {/* <li className="dropdown-item">
              <div className="d-flex align-items-center justify-content-between">
                <div>
                  <a className="f-w-500" href="index.html#">
                    <i className="ph-duotone  ph-detective pe-1 f-s-20" /> Incognito
                  </a>
                </div>
                <div className="flex-shrink-0">
                  <div className="form-check form-switch">
                    <input className="form-check-input form-check-primary" id="incognitoSwitch" type="checkbox" />
                  </div>
                </div>
              </div>
            </li>
            <li className="dropdown-item">
              <a className="mb-0 text-secondary f-w-500" href="sign_up.html" target="_blank">
                <i className="ph-bold  ph-plus pe-1 f-s-20" /> Add account
              </a>
            </li> */}
            <li className="app-divider-v dotted py-1" />
            <li className="dropdown-item">
              <a onClick={handleLogout} className="mb-0 text-danger">
                <i className="ph-duotone  ph-sign-out pe-1 f-s-20" /> Log Out
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    {props.sidebar}
  
    <div className="menu-navs">
      <span className="menu-previous"><i className="ti ti-chevron-left" /></span>
      <span className="menu-next"><i className="ti ti-chevron-right" /></span>
    </div>
  </nav>
  {/* Menu Navigation ends */}
  <div className="app-content">
      <div className>
      {/* Header Section starts */}
      <header className="header-main">
        <div className="container-fluid">
          <div className="row">
            <div className="col-8 col-sm-6 d-flex align-items-center header-left p-0">
              <span className="header-toggle" onClick={toggleSidebar} style={{ cursor: 'pointer' }}>
                <i className="ph ph-squares-four" />
              </span>
              <div className="header-searchbar w-100">
                <form action="index.html#" className="mx-sm-3 app-form app-icon-form ">
                  {/* <div className="position-relative">
                    <input aria-label="Search" className="form-control" placeholder="Search..." type="search" />
                    <i className="ti ti-search text-dark" />
                  </div> */}
                </form>
              </div>
            </div>
            <div className="col-4 col-sm-6 d-flex align-items-center justify-content-end header-right p-0">
              <ul className="d-flex align-items-center">
                <li className="header-language">
                  <div className="flex-shrink-0 dropdown" id="lang_selector">
                    <a aria-expanded="false" className="d-block head-icon ps-0" data-bs-toggle="dropdown" href="index.html#">
                      <div className="lang-flag lang-en ">
                        <span className="flag rounded-circle overflow-hidden">
                          <i className />
                        </span>
                      </div>
                    </a>
                    <ul className="dropdown-menu language-dropdown header-card border-0">
                      <li className="lang lang-en selected dropdown-item p-2" data-bs-placement="top" data-bs-toggle="tooltip" title="US">
                        <span className="d-flex align-items-center">
                          <i className="flag-icon flag-icon-usa flag-icon-squared rounded-circle f-s-20" />
                          <span className="ps-2">US</span>
                        </span>
                      </li>
                      <li className="lang lang-pt dropdown-item p-2" title="FR">
                        <span className="d-flex align-items-center">
                          <i className="flag-icon flag-icon-fra flag-icon-squared rounded-circle f-s-20" />
                          <span className="ps-2">France</span>
                        </span>
                      </li>
                      <li className="lang lang-es dropdown-item p-2" title="UK">
                        <span className="d-flex align-items-center">
                          <i className="flag-icon flag-icon-gbr flag-icon-squared rounded-circle f-s-20" />
                          <span className="ps-2">UK</span>
                        </span>
                      </li>
                      <li className="lang lang-es dropdown-item p-2" title="IT">
                        <span className="d-flex align-items-center">
                          <i className="flag-icon flag-icon-ita flag-icon-squared rounded-circle f-s-20" />
                          <span className="ps-2">Italy</span>
                        </span>
                      </li>
                    </ul>
                  </div>
                </li>
                <li className="header-apps">
                  {/* <a aria-controls="appscanvasRights" className="d-block head-icon bg-light-dark rounded-circle f-s-22 p-2" data-bs-target="#appscanvasRights" data-bs-toggle="offcanvas" href="index.html#" role="button">
                    <i className="ph ph-bounding-box" />
                  </a> */}
                  <div aria-labelledby="appscanvasRightsLabel" className="offcanvas offcanvas-end header-apps-canvas" id="appscanvasRights" tabIndex={-1}>
                    <div className="offcanvas-header">
                      <h5 className="offcanvas-title" id="appscanvasRightsLabel">Shortcut</h5>
                      <div className="app-dropdown flex-shrink-0">
                        <a aria-expanded="false" className=" p-1" data-bs-auto-close="outside" data-bs-toggle="dropdown" href="index.html#" role="button">
                          <i className="ph-bold  ph-faders-horizontal f-s-20" />
                        </a>
                        <ul className="dropdown-menu mb-3">
                          <li className="dropdown-item">
                            <a href="setting.html" target="_blank">
                              Privacy Settings
                            </a>
                          </li>
                          <li className="dropdown-item">
                            <a href="setting.html" target="_blank">
                              Account Settings
                            </a>
                          </li>
                          <li className="dropdown-item">
                            <a href="setting.html" target="_blank">
                              Accessibility
                            </a>
                          </li>
                          <li className="dropdown-divider" />
                          <li className="dropdown-item border-0">
                            <a aria-expanded="false" data-bs-toggle="dropdown" href="index.html#" role="button">
                              More Settings
                            </a>
                            <ul className="dropdown-menu sub-menu">
                              <li className="dropdown-item">
                                <a href="setting.html" target="_blank">
                                  Backup and Restore
                                </a>
                              </li>
                              <li className="dropdown-item">
                                <a href="setting.html" target="_blank">
                                  <span>Data Usage</span>
                                </a>
                              </li>
                              <li className="dropdown-item">
                                <a href="setting.html" target="_blank">
                                  <span>Theme</span>
                                </a>
                              </li>
                              <li className="dropdown-item d-flex align-items-center justify-content-between">
                                <a href="index.html#">
                                  <p className="mb-0">Notification</p>
                                </a>
                                <div className="flex-shrink-0">
                                  <div className="form-check form-switch">
                                    <input className="form-check-input  form-check-primary" id="notificationSwitch" type="checkbox" />
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="offcanvas-body app-scroll">
                      <div className="row row-cols-3 g-2">
                        <div className="d-flex-center text-center">
                          <Link to="/operations/dashboard" className="text-light-primary w-100 rounded-3 py-3 px-2 ">
                            <span>
                              <i className="ph-light  ph-shopping-bag-open  f-s-30" />
                            </span>
                            <p className="mb-0 f-w-500 text-dark">Operations</p>
                          </Link>
                        </div>
                        <div className="d-flex-center text-center">
                          <Link to="/general/dashboard" className="text-light-danger w-100 rounded-3 py-3 px-2 ">
                            <span>
                              <i className="ph-light  ph-envelope  f-s-30" />
                            </span>
                            <p className="mb-0 f-w-500 text-dark">General</p>
                          </Link>
                        </div>
                        <div className="d-flex-center text-center">
                          <Link to="/hr/dashboard"  className="text-light-success w-100 rounded-3 py-3 px-2 " >
                            <span>
                              <i className="ph-light  ph-chat-circle-text  f-s-30" />
                            </span>
                            <p className="mb-0 f-w-500 text-dark">HR</p>
                          </Link>
                        </div>
                        <div className="d-flex-center text-center">
                          <Link to="/finance/dashboard" className="text-light-warning w-100 rounded-3 py-3 px-2 ">
                            <span>
                              <i className="ph-light  ph-projector-screen-chart  f-s-30" />
                            </span>
                            <p className="mb-0 f-w-500 text-dark">Finance</p>
                          </Link>
                        </div>
                        {/* <div className="d-flex-center text-center">
                          <a className="text-light-info w-100 rounded-3 py-3 px-2 " href="invoice.html" target="_blank">
                            <span>
                              <i className="ph-light  ph-scroll f-s-30" />
                            </span>
                            <p className="mb-0 f-w-500 text-dark">Invoice</p>
                          </a>
                        </div>
                        <div className="d-flex-center text-center">
                          <a className="text-light-dark w-100 rounded-3 py-3 px-2 " href="blog.html" target="_blank">
                            <span>
                              <i className="ph-light  ph-notebook f-s-30" />
                            </span>
                            <p className="mb-0 f-w-500 text-dark">Blog</p>
                          </a>
                        </div>
                        <div className="d-flex-center text-center">
                          <a className="text-light-danger w-100 rounded-3 py-3 px-2 " href="calendar.html" target="_blank">
                            <span>
                              <i className="ph-light  ph-calendar f-s-30" />
                            </span>
                            <p className="mb-0 f-w-500 text-dark">Calender</p>
                          </a>
                        </div>
                        <div className="d-flex-center text-center">
                          <a className="text-light-warning w-100 rounded-3 py-3 px-2 " href="file_manager.html" target="_blank">
                            <span>
                              <i className="ph-light  ph-folder-open f-s-30" />
                            </span>
                            <p className="mb-0 f-w-500 text-dark txt-ellipsis-1">File
                              Manager</p>
                          </a>
                        </div>
                        <div className="d-flex-center text-center">
                          <a className="text-light-primary w-100 rounded-3 py-3 px-2 " href="gallery.html" target="_blank">
                            <span>
                              <i className="ph-light  ph-google-photos-logo f-s-30" />
                            </span>
                            <p className="mb-0 f-w-500 text-dark">Gallery</p>
                          </a>
                        </div>
                        <div className="d-flex-center text-center">
                          <a className="text-light-success w-100 rounded-3 py-3 px-2 " href="profile.html" target="_blank">
                            <span>
                              <i className="ph-light  ph-users-three f-s-30" />
                            </span>
                            <p className="mb-0 f-w-500 text-dark">Profile</p>
                          </a>
                        </div>
                        <div className="d-flex-center text-center">
                          <a className="text-light-secondary w-100 rounded-3 py-3 px-2 " href="kanban_board.html" target="_blank">
                            <span>
                              <i className="ph-light  ph-selection-foreground f-s-30" />
                            </span>
                            <p className="mb-0 f-w-500 text-dark">Task Board</p>
                          </a>
                        </div> */}
                        <div className="d-flex-center text-center">
                          <a className="d-flex-center text-light-secondary w-100 h-100 rounded-3 p-2 dashed-1-secondary" href="kanban_board.html" target="_blank">
                            <span>
                              <i className="ph-light  ph-plus f-s-30" />
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                {/* <li className="header-cart">
                  <a aria-controls="cartcanvasRight" className="d-block head-icon position-relative bg-light-dark rounded-circle f-s-22 p-2" data-bs-target="#cartcanvasRight" data-bs-toggle="offcanvas" href="index.html#" role="button">
                    <i className="ph ph-shopping-cart-simple" />
                    <span className="position-absolute translate-middle badge rounded-pill bg-danger badge-notification">4</span>
                  </a>
                  <div aria-labelledby="cartcanvasRightLabel" className="offcanvas offcanvas-end header-cart-canvas" id="cartcanvasRight" tabIndex={-1}>
                    <div className="offcanvas-header">
                      <h5 className="offcanvas-title" id="cartcanvasRightLabel">Cart</h5>
                      <button aria-label="Close" className="btn-close" data-bs-dismiss="offcanvas" type="button" />
                    </div>
                    <div className="offcanvas-body app-scroll p-0">
                      <div className="head-container">
                        <div className="head-box">
                          <span className="b-1-light bg-light-primary h-45 w-45 d-flex-center b-r-6">
                            <img alt="cart" className="img-fluid p-1" src="../assets/images/header/cart/01.png" />
                          </span>
                          <div className="flex-grow-1 ms-2">
                            <a className="mb-0 f-w-600 f-s-16" href="product_details.html" target="_blank"> Backpacks (3<i className="ti ti-star-filled text-warning f-s-12" />)
                            </a>
                            <div>
                              <span className="text-dark"><span className="text-secondary f-w-400">size</span> : M</span>
                              <span className="text-dark ms-2"><span className="text-secondary f-w-400">color</span> :Pink</span>
                            </div>
                          </div>
                          <div className="text-end">
                            <i className="ph ph-trash f-s-18 text-danger close-btn" />
                            <p className="text-muted f-w-500 mb-0">$600.50 x 1</p>
                          </div>
                        </div>
                        <div className="head-box">
                          <span className="b-1-light bg-light-primary h-45 w-45 d-flex-center b-r-6">
                            <img alt="cart" className="img-fluid p-1" src="../assets/images/header/cart/05.png" />
                          </span>
                          <div className="flex-grow-1 ms-2">
                            <a className="mb-0 f-w-600 f-s-16" href="product_details.html" target="_blank"> Women's Watch (4<i className="ti ti-star-filled text-warning f-s-12" />)</a>
                            <div>
                              <span className="text-dark"><span className="text-secondary f-w-400">size</span> : S</span>
                              <span className="text-dark ms-2"><span className="text-secondary f-w-400">color</span> :Rose Gold</span>
                            </div>
                          </div>
                          <div className="text-end">
                            <i className="ph ph-trash f-s-18 text-danger close-btn" />
                            <p className="text-muted f-w-500 mb-0">$519.10 x 2</p>
                          </div>
                        </div>
                        <div className="head-box">
                          <span className="b-1-light bg-light-primary h-45 w-45 d-flex-center b-r-6">
                            <img alt="cart" className="img-fluid p-1" src="../assets/images/header/cart/04.png" />
                          </span>
                          <div className="flex-grow-1 ms-2">
                            <a className="mb-0 f-w-600 f-s-16" href="product_details.html" target="_blank">Sandals (5 <i className="ti ti-star-filled text-warning f-s-12" />)</a>
                            <div>
                              <span className="text-dark"><span className="text-secondary f-w-400">size</span> : 8</span>
                              <span className="text-dark ms-2"><span className="text-secondary f-w-400">color</span> :White</span>
                            </div>
                          </div>
                          <div className="text-end">
                            <i className="ph ph-trash f-s-18 text-danger close-btn" />
                            <p className="text-muted f-w-500 mb-0">$390 x 2</p>
                          </div>
                        </div>
                        <div className="head-box ">
                          <span className="b-1-light bg-light-primary h-45 w-45 d-flex-center b-r-6">
                            <img alt="cart" className="img-fluid p-1" src="../assets/images/header/cart/03.png" />
                          </span>
                          <div className="flex-grow-1 ms-2">
                            <a className="mb-0 f-w-600 f-s-16" href="product_details.html" target="_blank"> Jackets (3<i className="ti ti-star-filled text-warning f-s-12" />)</a>
                            <div>
                              <span className="text-dark"><span className="text-secondary f-w-400">size</span> : XL</span>
                              <span className="text-dark ms-2"><span className="text-secondary f-w-400">color</span> :Blue</span>
                            </div>
                          </div>
                          <div className="text-end">
                            <i className="ph ph-trash f-s-18 text-danger close-btn" />
                            <p className="text-muted f-w-500 mb-0">$300.00 x 2</p>
                          </div>
                        </div>
                        <div className="head-box ">
                          <span className="b-1-light bg-light-primary h-45 w-45 d-flex-center b-r-6">
                            <img alt="cart" className="img-fluid p-1" src="../assets/images/header/cart/02.png" />
                          </span>
                          <div className="flex-grow-1 ms-2">
                            <a className="mb-0 f-w-600 f-s-16" href="product_details.html" target="_blank"> Shoes (3<i className="ti ti-star-filled text-warning f-s-12" />)</a>
                            <div>
                              <span className="text-dark"><span className="text-secondary f-w-400">size</span> : 9</span>
                              <span className="text-dark ms-2"><span className="text-secondary f-w-400">color</span> :White</span>
                            </div>
                          </div>
                          <div className="text-end">
                            <i className="ph ph-trash f-s-18 text-danger close-btn" />
                            <p className="text-muted f-w-500 mb-0">$450.00 x 1</p>
                          </div>
                        </div>
                        <div className="hidden-massage py-4 px-3">
                          <div>
                            <i className="ph-duotone  ph-shopping-bag-open f-s-50 text-primary" />
                            <h6 className="mb-0">Your Cart is Empty</h6>
                            <p className="text-secondary mb-0">Add some items :)</p>
                            <a className="btn btn-light-primary btn-xs mt-2" href="product_details.html">Shop
                              Now</a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="offcanvas-footer">
                      <div className="head-box-footer p-3">
                        <div className="mb-4">
                          <h6 className="text-muted f-w-600">Total <span className="float-end text-primary">$3,468.00</span></h6>
                        </div>
                        <div className="header-cart-btn">
                          <a className="btn btn-primary" href="cart.html" role="button" target="_blank">
                            <i className="ti ti-eye" /> View Cart</a>
                          <a className="btn btn-success" href="checkout.html" role="button" target="_blank">
                            Checkout <i className="ti ti-shopping-cart" /></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </li> */}
                {/* <li className="header-dark">
                  <div className="sun-logo head-icon bg-light-dark rounded-circle f-s-22 p-2">
                    <i className="ph ph-moon-stars" />
                  </div>
                  <div className="moon-logo head-icon bg-light-dark rounded-circle f-s-22 p-2">
                    <i className="ph ph-sun-dim" />
                  </div>
                </li> */}
                <li className="header-notification">
                  <a aria-controls="notificationcanvasRight" className="d-block head-icon position-relative bg-light-dark rounded-circle f-s-22 p-2" data-bs-target="#notificationcanvasRight" data-bs-toggle="offcanvas" href="index.html#" role="button">
                    <i className="ph ph-bell" />
                    {user?.unread_notifications?.length?(
                                          <span className="position-absolute translate-middle p-1 bg-primary border border-light rounded-circle animate__animated animate__fadeIn animate__infinite animate__slower" />

                    ):''}
                  </a>
                  <div aria-labelledby="notificationcanvasRightLabel" className="offcanvas offcanvas-end header-notification-canvas" id="notificationcanvasRight" tabIndex={-1}>
                    <div className="offcanvas-header">
                      <h5 className="offcanvas-title" id="notificationcanvasRightLabel">
                        Notification</h5>
                      <button aria-label="Close" className="btn-close" data-bs-dismiss="offcanvas" type="button" />
                    </div>
                    <div className="offcanvas-body app-scroll p-0">
                      <div className="head-container">
                       {/*  show list of unread notification using below div */}                       {user?.unread_notifications && user.unread_notifications.length > 0 ? (
                          user.unread_notifications.map((notification) => (
                            <div className="notification-message head-box" key={notification.id}>
                              <div className="message-content-box flex-grow-1 pe-2">
                                <a className="f-s-15 text-dark mb-0" href="#">
                                  <span className="f-w-500 text-dark">{notification.data.body}</span>
                                  <br />
                                  {notification.data.message}
                                </a>
                              </div>
                              <div className="text-end">
                                <i className="ph ph-trash f-s-18 text-danger close-btn" />
                                <div>
                                  <span className="badge text-light-primary">
                                    {new Date(notification.created_at).toLocaleDateString()}
                                  </span>
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className="hidden-massage py-4 px-3">
                            <div>
                              <i className="ph-duotone  ph-bell-ringing f-s-50 text-primary" />
                            </div>
                            <div>
                              <h6 className="mb-0">No New Notifications</h6>
                              <p className="text-dark">When you have any notifications, they will appear here.</p>
                            </div>
                          </div>
                        )}
                        
                        {/* <div className="notification-message head-box">
                          <div className="message-content-box flex-grow-1 pe-2">
                            <a className="f-s-15 text-dark mb-0" href="read_email.html"><span className="f-w-500 text-dark">Gene Hart</span> wants to
                              edit <span className="f-w-500 text-dark">Report.doc</span></a>
                            <div>
                              <a className="d-inline-block f-w-500 text-success me-1" href="index.html#">Approve</a>
                              <a className="d-inline-block f-w-500 text-danger" href="index.html#">Deny</a>
                            </div>
                          </div>
                          <div className="text-end">
                            <i className="ph ph-trash f-s-18 text-danger close-btn" />
                            <div>
                              <span className="badge text-light-primary"> sep 23 </span>
                            </div>
                          </div>
                        </div> */}
                        {/* <div className="notification-message head-box">
                          <div className="message-content-box flex-grow-1 pe-2">
                            <a className="f-s-15 text-dark mb-0" href="read_email.html"><span className="f-w-500 text-dark">Gene Hart</span> wants to
                              edit <span className="f-w-500 text-dark">Report.doc</span></a>
                            <div>
                              <a className="d-inline-block f-w-500 text-success me-1" href="index.html#">Approve</a>
                              <a className="d-inline-block f-w-500 text-danger" href="index.html#">Deny</a>
                            </div>
                          </div>
                          <div className="text-end">
                            <i className="ph ph-trash f-s-18 text-danger close-btn" />
                            <div>
                              <span className="badge text-light-primary"> sep 23 </span>
                            </div>
                          </div>
                        </div>
                        <div className="notification-message head-box">
                          <div className="message-content-box flex-grow-1 pe-2">
                            <a className="f-s-15 text-dark mb-0" href="read_email.html">Hey
                              <span className="f-w-500 text-dark">Emery McKenzie</span>,
                              get ready: Your order from <span className="f-w-500 text-dark">@Shopper.com</span></a>
                          </div>
                          <div className="text-end">
                            <i className="ph ph-trash f-s-18 text-danger close-btn" />
                            <div>
                              <span className="badge text-light-primary"> sep 23 </span>
                            </div>
                          </div>
                        </div>
                        <div className="notification-message head-box">
                          <div className="message-content-box flex-grow-1 pe-2">
                            <a className="f-s-15 text-dark mb-0" href="read_email.html"><span className="f-w-500 text-dark">Simon Young</span> shared
                              a file called <span className="f-w-500 text-dark">Dropdown.pdf</span></a>
                          </div>
                          <div className="text-end">
                            <i className="ph ph-trash f-s-18 text-danger close-btn" />
                            <div>
                              <span className="badge text-light-primary"> 30 min</span>
                            </div>
                          </div>
                        </div>
                        <div className="notification-message head-box">
                          <div className="message-content-box flex-grow-1 pe-2">
                            <a className="f-s-15 text-dark mb-0" href="read_email.html"><span className="f-w-500 text-dark">Becky G. Hayes</span> has
                              added a comment to <span className="f-w-500 text-dark">Final_Report.pdf</span></a>
                          </div>
                          <div className="text-end">
                            <i className="ph ph-trash f-s-18 text-danger close-btn" />
                            <div>
                              <span className="badge text-light-primary"> 45 min</span>
                            </div>
                          </div>
                        </div>
                        <div className="notification-message head-box">
                          <div className="message-content-box  flex-grow-1 pe-2">
                            <a className="f-s-15 text-dark mb-0 " href="read_email.html"><span className="f-w-600 text-dark">@Romaine</span>
                              invited you to a meeting
                            </a>
                            <div>
                              <a className="d-inline-block f-w-500 text-success me-1" href="index.html#">Join</a>
                              <a className="d-inline-block f-w-500 text-danger" href="index.html#">Decline</a>
                            </div>
                          </div>
                          <div className="text-end">
                            <i className="ph ph-trash f-s-18 text-danger close-btn" />
                            <div>
                              <span className="badge text-light-primary"> 1 hour ago </span>
                            </div>
                          </div>
                        </div> */}
                        {/* <div className="hidden-massage py-4 px-3">
                          <div>
                            <i className="ph-duotone  ph-bell-ringing f-s-50 text-primary" />
                          </div>
                          <div>
                            <h6 className="mb-0">Notification Not Found</h6>
                            <p className="text-dark">When you have any notifications added
                              here,will
                              appear here.
                            </p>
                          </div>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </header>
      {/* Header Section ends */}
      {/* Body main section starts */}

      {[props.children]}
      
    </div>
  </div>
  {/* Body main section ends */}
  {/* tap on top */}
  <div className="go-top">
    <span className="progress-value">
      <i className="ti ti-chevron-up" />
    </span>
  </div>
  {/* Footer Section starts*/}
  <footer>
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-9 col-12">
          <p className="footer-text f-w-600 mb-0">Copyright © {new Date().getFullYear()} <span className='text-danger'>{process.env.REACT_APP_NAME} </span> by {process.env.REACT_APP_PROVIDER}.</p>
        </div>
        <div className="col-md-3">
          <div className="footer-text text-end">
            <a className="f-w-500 text-primary" href="mailto:sajras@milma.com"> Need Help <i className="ti ti-help" /></a>
          </div>
        </div>
      </div>
    </div>
  </footer>
  {/* Footer Section ends*/}
</div>


      </>

    </>
  )
}

export default AppLayout